import React from 'react';

const Blogs = () => {
    return (
        <div className='lg:w-9/12 my-10 mx-auto'>
            <h1 className='text-5xl font-semibold'>Blogs is coming soon...</h1>
        </div>
    );
};

export default Blogs;